import { from, Observable, throwError } from 'rxjs';
import { flatMap } from 'rxjs/operators';
import ApiWrapper from '@/api/ApiWrapper';

export default function unwrapApiWrapper<T>(observable: Observable<ApiWrapper<T>>): Observable<T | null> {
    return observable.pipe(flatMap((wrapper) => (wrapper.success ? from([wrapper.data]) : throwError(wrapper.data))));
}
